import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref } from "../../../../adapter-vue";
import {
  CUSTOM_BASIC_EMOJI_URL,
  CUSTOM_BASIC_EMOJI_URL_MAPPING,
} from "../../emoji-config";
import { isPC } from "../../../../utils/env";
interface IProps {
  content: Record<string, any>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'message-text',
  props: {
    content: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { content: Record<string, any> }


const data = ref();
watchEffect(() => {
  data.value = props.content;
  data.value.text?.forEach(
    (item: {
      name: string;
      text?: string;
      src?: string;
      type?: string;
      emojiKey?: string;
    }) => {
      if (item.name === "img" && item?.type === "custom") {
        if (!CUSTOM_BASIC_EMOJI_URL) {
          console.warn(
            "CUSTOM_BASIC_EMOJI_URL is required for custom emoji, please check your CUSTOM_BASIC_EMOJI_URL."
          );
        } else if (
          !item.emojiKey ||
          !CUSTOM_BASIC_EMOJI_URL_MAPPING[item.emojiKey]
        ) {
          console.warn(
            "emojiKey is required for custom emoji, please check your emojiKey."
          );
        } else {
          item.src =
            CUSTOM_BASIC_EMOJI_URL +
            CUSTOM_BASIC_EMOJI_URL_MAPPING[item.emojiKey];
        }
      }
    }
  );
});

return { __sfc: true,props, data, isPC }
}

})